import { ErrorHandler, Injectable } from '@angular/core';
import { ErreurSpa } from '../modeles/erreur-spa.modele';
import { TracingSpaApiService } from '../../shared/services/tracing-spa-api.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  constructor(private readonly _tracingSpaApiService: TracingSpaApiService) {}

  handleError(error: any): void {
    const erreurSpa = this.createErreurSpa(error);
    this._tracingSpaApiService.postLogErreurSpa(erreurSpa);
  }

  createErreurSpa(error): ErreurSpa {
    return {
      message: this.extractFirstLine(error.message),
      url: document.location.href,
      userAgent: navigator.userAgent,
      stackTrace: error.stack,
      date: new Date(Date.now()).toISOString(),
      type: error.name || 'unknown'
    };
  }

  private extractFirstLine(message: string): string {
    if (typeof message === 'string' && message.length > 0) {
      return message.split('\n')[0];
    }
    return message;
  }
}
